<!-- SohaTab.vue -->
<template>
  <TabView 
    :active-index="activeIndex" 
    class="soha-tabview"
    :class="{ 'hide-headers': hideHeaders }"
    :lazy="true"
    scrollable
    @tab-change="onTabChange"
  >
    <TabPanel 
      v-for="(tab, index) in tabs" 
      :key="index"
      :lazy="true"
    >
      <template #header>
        <span>{{ tab.title }}</span>
      </template>
      <slot :name="`tab-${index}`" />
    </TabPanel>
  </TabView>
</template>

<script>
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';

export default {
  name: "SohaTab",
  components: {
    TabView,
    TabPanel
  },
  props: {
    tabs: {
      type: Array,
      required: true
    },
    activeIndex: {
      type: Number,
      default: 0
    },
    hideHeaders: {
      type: Boolean,
      default: false
    },
  },

  emits: ['onClick'],

  methods: {
    onTabChange(event) {
      this.$emit('onClick', event.index);
    }
  }
};
</script>

<style scoped>
.soha-tabview.hide-headers :deep(.p-tabview-nav) {
  display: none !important;
}
.soha-tabview {
  direction: rtl;
  width: 100%;
}

:deep(.p-tabview .p-tabview-nav) {
  border: none;
  background: transparent;
}

:deep(.p-tabview .p-tabview-nav li .p-tabview-nav-link) {
  background: transparent;
  border: none;
  color: #6c757d;
  font-weight: 600;
  padding: 1rem 1.5rem;
}

:deep(.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link) {
  color: var(--primary-color);
  border-bottom: 2px solid var(--primary-color);
}

:deep(.p-tabview .p-tabview-panels) {
  background: transparent;
  border: none;
  padding: 1rem 0;
}
:deep(.p-tabview-tablist-item) {
  white-space: nowrap;
}
</style>